/* eslint-disable */
function checkError(data) {
  let error = true;

  if (data && data.response && data.response.status && data.response.status >= 200 && data.response.status < 300) {
    error = false;
  } else {
    if (data) {
      data.message = 'errors.general';
    }

    if (data && data.response && data.response.status && data.response.status === 400) {
      data.message = 'errors.400';
    }

    if (data && data.response && data.response.status && data.response.status === 401) {
      data.message = 'errors.401';

      if (data.json && data.json.error === 'invalid_credentials') {
        data.message = 'errors.invalidCredentials';
      }

      if (data.json && data.json.errors && data.json.errors[0] && data.json.errors[0].source === 'INVALID_CURRENT_PASSWORD') {
        data.message = 'errors.invalidPassword';
      }
    }

    if (data && data.response && data.response.status && data.response.status === 404) {
      data.message = 'errors.404';

      if (data.json && data.json.errors && data.json.errors[0] && data.json.errors[0].source === 'EMAIL_UNKNOWN') {
        data.message = 'errors.emailNotFound';
      }
    }

    if (data && data.response && data.response.status && data.response.status === 422) {
      data.message = 'errors.fillAllFields';

      if (data.json && data.json.errors && data.json.errors.password && data.json.errors.password[0] === 'validation.min.string') {
        data.message = 'errors.validation.min.string';
      }

      if (data.json && data.json.password && data.json.password[0] === 'validation.min.string') {
        data.message = 'errors.validation.min.string';
      }

      if (data.json && data.json.errors && data.json.errors.email && data.json.errors.email[0] === 'validation.exists') {
        data.message = 'errors.emailNotFound';
      }

      if (data.json && data.json.email && data.json.email[0] === 'validation.exists') {
        data.message = 'errors.emailNotFound';
      }
    }
  }

  return error;
}

export default checkError;



// WEBPACK FOOTER //
// ./js/utils/check-error.js